module.exports = __webpack_public_path__ + "static/img/piano-player--small.68cfaa5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/school-hall/piano-player--small.svg
// module id = 181
// module chunks = 2